import React from 'react';

import { FilesReader } from 'components/shared/FilesReader';

const SUPPORTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

type PropTypes = {
  onImageLoaded: (file: File) => void;
  onException: () => void;
  onError: (errors: string[]) => void;
  disabled?: boolean;
};

export const ImageInput: React.FC<PropTypes> = ({
  onException,
  onError,
  onImageLoaded,
  children,
  disabled,
}) => {
  const handleLoadFinish = ({ file }: { file: File }) => {
    onImageLoaded(file);
  };

  return (
    <FilesReader
      allowedMIMETypes={SUPPORTED_IMAGE_TYPES}
      maxSizeInMb={20}
      multiple={false}
      onError={onException}
      onAbort={onException}
      onValidationError={onError}
      onLoadFinish={handleLoadFinish}
      disabled={disabled}
    >
      {children || (
        <svg
          width="20"
          height="20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="12" r="3" stroke="#000" strokeWidth="1.5" />
          <path
            clipRule="evenodd"
            d="M1 6h4l2-3h6l2 3h4v12H1V6z"
            stroke="#000"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </FilesReader>
  );
};
